module.exports = __webpack_public_path__ + "static/media/not-implemented.f1bc6080.png";